export default __webpack_public_path__ + "static/media/parts1.09f829cf.jpg";